import React, { useMemo } from "react";
import Creative from "./print-photo-editor-creative/PrintPhotoEditorCreative";

import { MutedIcon, PauseIcon } from "../../../Previews/Svg";

import { isVideo } from "../../../Previews/utils";

import * as SC from "./PrintCampaignCreatePhotoEditor.styled";

import { resizeImage } from "../../../../../utils/images";

const PrintCampaignCreatePhotoEditor = ({
  creatives,
  selectedCreativeIndexToEdit,
  minHeight,
  maxHeight,
  width,
  borderRadius = "0",
  isLogo = false
}) => {
  const creative = useMemo(
    () => resizeImage({ url: creatives[selectedCreativeIndexToEdit] || creatives[0] || "" }),
    [creatives, selectedCreativeIndexToEdit]
  );

  const atVideo = useMemo(() => {
    if (!isLogo && creative) {
      return isVideo(creative);
    }
    return false;
  }, [creative, isLogo]);

  return (
    <SC.EditorWrapper>
      <SC.MediaActions active={atVideo}>
        <SC.MuteButton>
          <MutedIcon />
        </SC.MuteButton>
        <SC.PlayingButton>
          <PauseIcon />
        </SC.PlayingButton>
      </SC.MediaActions>

      <SC.CreativeAndUploaderWrapper style={{ borderRadius }}>
        <SC.CreativeWrapper
          key={creative}
          width={width}
          minHeight={minHeight}
          maxHeight={maxHeight}
        >
          <Creative url={creative} playing={false} muted={true} />
        </SC.CreativeWrapper>
      </SC.CreativeAndUploaderWrapper>
    </SC.EditorWrapper>
  );
};

export default PrintCampaignCreatePhotoEditor;
